import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToBottomButton from '../components/ui/ScrollToBottomButton';
import heroImage from '../assets/1.webp';
import heroImageMobile from '../assets/2.webp';

const ReturnAndRefundPolicy = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const policies = [
    {
      title: 'Within 48 hours prior to check-in',
      points: [
        'No refund. The entire advance payment will be forfeited.',
      ],
    },
    {
      title: 'Between 14 days and 48 hours prior to check-in',
      points: [
        '50% of the advance payment will be forfeited.',
      ],
    },
    {
      title: '14 days or more prior to check-in',
      points: [
        'Full refund after 10% deduction towards administrative and transfer charges.',
      ],
    },
  ];

  return (
    <>
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${isMobile ? heroImageMobile : heroImage})` }}
        data-aos="fade-in"
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-aos="fade-up">Return and Refund Policy</h1>
          <p className="mt-4 text-lg text-gray-300" data-aos="fade-up" data-aos-delay="100">Our commitment to a fair and transparent process</p>
        </div>
        <ScrollToBottomButton targetId="refund-content" />
      </section>

      <main id="refund-content" className="bg-gray-50 py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12" data-aos="fade-up">
            <h2 className="text-3xl font-semibold text-dark-green">Our Refund Policy</h2>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              At Pineridge Hotel, we strive to provide a seamless experience. We understand that plans can change, and we aim to be as flexible and transparent as possible with refunds and cancellations.
            </p>
          </div>

          <div className="space-y-8">
            {policies.map((policy, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-beige" data-aos="fade-up">
                <h3 className="text-xl font-semibold text-dark-green mb-4">{policy.title}</h3>
                {policy.content && <p className="text-gray-700 mb-4">{policy.content}</p>}
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  {policy.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          

          <div className="mt-12 text-center" data-aos="fade-up">
            <p className="text-lg text-gray-600">
              We thank you for choosing Pineridge Hotel and look forward to welcoming you soon.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default ReturnAndRefundPolicy;